import { writable, derived } from 'svelte/store';

/** Store for your data. 
This assumes the data you're pulling back will be an array.
If it's going to be an object, default this to an empty object.
**/
export const apiData = writable([]);

/** Data transformation.
For our use case, we only care about the drink names, not the other information.
Here, we'll create a derived store to hold the drink names.
**/
export const nfts = derived(apiData, ($apiData) => {
  if ($apiData){
    
    let scenes = $apiData.reduce((curr, val) => {

      // Check if scene already exist else create it
      let scene = curr.find(g => g.scene === `${val.scene}`)
      if (scene) {
        // Only add timeline to scene if it doens't exist
        scene.totalPrice += val.price;
        scene.totalTimelines += (val.merged > 1 ? val.merged : 1);
        scene.timelines.push(val);
      } else {
        curr.push({ scene: `${val.scene}`,img: val.img, totalPrice: val.price, totalTimelines: (val.merged > 1 ? val.merged : 1),  timelines: [ val ] }) 
      }
      return curr
    }, []);

    scenes.sort(function(a, b) {
      return b.totalTimelines - a.totalTimelines || a.totalPrice - b.totalPrice;
    });

    return scenes;
  }
  return [];
});